/**
 * Период платежа из ответа ГЦВП в виде с точками: `042026` → `04.2026`,
 * `15042026` → `15.04.2026`. Уже отформатированное значение и иное — как есть.
 */
export const formatPaymentPeriod = (value: string): string => {
  if (value.includes('.')) return value;
  return value.replace(/^(\d{2})?(\d{2})(\d{4})$/, (_, day, month, year) =>
    day ? `${day}.${month}.${year}` : `${month}.${year}`
  );
};
